import type { SVGProps } from 'react'

type Props = SVGProps<SVGSVGElement> & {
  angular?: boolean
}

function strokeAttrs(angular: boolean | undefined) {
  const a = !!angular
  return {
    fill: 'none' as const,
    stroke: 'currentColor',
    strokeWidth: a ? 2.25 : 1.85,
    strokeLinecap: (a ? 'square' : 'round') as 'round' | 'square',
    strokeLinejoin: (a ? 'miter' : 'round') as 'miter' | 'round',
  }
}

/** 时间线轮次操作：垂直三圆点，与导航图标尺寸一致 */
export function IconMoreVertical({ angular, className, ...rest }: Props) {
  const s = strokeAttrs(angular)
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden {...rest}>
      <circle cx="12" cy="5" r="1.5" {...s} />
      <circle cx="12" cy="12" r="1.5" {...s} />
      <circle cx="12" cy="19" r="1.5" {...s} />
    </svg>
  )
}

/** 存入图库：画框 + 左下角加号，与导航图库图标语义关联 */
export function IconSaveLibrary({ angular, className, ...rest }: Props) {
  const s = strokeAttrs(angular)
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden {...rest}>
      <rect x="4" y="4" width="16" height="16" rx="2" {...s} />
      <path d="M4 16l5-5 4 4 3-3" {...s} />
      <path d="M9.5 8.5h.01" {...s} />
      <path d="M15 15.5v3M13.5 17h3" {...s} />
    </svg>
  )
}

/** 追加生成：原图钉 + 右下小加号，表示"在此基础上再来一张" */
export function IconAppendGenerate({ angular, className, ...rest }: Props) {
  const s = strokeAttrs(angular)
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden {...rest}>
      <rect x="3.5" y="4.5" width="13" height="13" rx="1.5" {...s} />
      <path d="M3.5 15.5l3.5-3.5 2.8 2.8 2.4-2.4 4.3 4.3" {...s} />
      <path d="M7 8.5h.01" {...s} />
      <path d="M16.5 16.5v3M15 18h3" {...s} />
    </svg>
  )
}

/** 删除：垃圾桶轮廓，工具栏危险色图标统一使用 */
export function IconDelete({ angular, className, ...rest }: Props) {
  const s = strokeAttrs(angular)
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden {...rest}>
      <path d="M4.5 7h15" {...s} />
      <path d="M9.5 4.5h5a1 1 0 0 1 1 1V7h-7V5.5a1 1 0 0 1 1-1Z" {...s} />
      <path d="M6.5 7.5v11a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5V7.5" {...s} />
      <path d="M10 11.5v5M14 11.5v5" {...s} />
    </svg>
  )
}

/** 重试生成：循环箭头，表示"再来一次" */
export function IconRetryRound({ angular, className, ...rest }: Props) {
  const s = strokeAttrs(angular)
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className={className} aria-hidden {...rest}>
      <path d="M19.5 12a7.5 7.5 0 1 1-2.2-5.3" {...s} />
      <path d="M19.5 4.5v4h-4" {...s} />
    </svg>
  )
}
